import React, { useRef, useState } from 'react';
import axios from 'axios';
import "./Website.css";
import flashMessage from '../HelperFunctions';


function Website({ organization, onChange }) {
  const [isSaving, setIsSaving] = useState(false);  // State to handle "saving..." message
  const placeholderText = `example.com`;

  const typingTimer = useRef(null);
  const phoneInputRef = useRef(null);

  const handleInputChange = (e) => {
    onChange(e.target.value);
  };

  return (

    <div className="customize-ai-section" style={{ width: '250px' }}>
      <span>Website</span>
      <input
        data-say-id="knowledge-base-website"
        ref={phoneInputRef}
        className="website-text"
        placeholder={placeholderText}
        defaultValue={organization.business_website}
        onChange={handleInputChange}
      />
      {/* <div className='business-phone-status-wrapper'>
        {isSaving ? (<img className="saving-animation" src="/images/saving.gif" alt="Saving..." />) : (null)}
      </div> */}

    </div>

  );
}

export default Website
